module.exports = __webpack_public_path__ + "img/q.7457d7a5.svg";